import { useState } from 'react';
import './ResourceCard.css';

// Artifacts longer than this get clipped with a fade and a control to open them.
const CLIP_AT = 14;

// Read off the artifact itself. Bullet lines are the rules a prompt imposes, so
// the count tells you how much it constrains before you read a word of it.
function measure(content) {
  const lines = content.split('\n');
  const rules = lines.filter((line) => /^\s*[*-]\s+\S/.test(line)).length;
  const words = content
    .replace(/^\s*#{1,6}\s+/gm, '') // heading markers aren't words
    .replace(/^\s*[*-]\s+/gm, '') // nor are bullet markers
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
  return { lines: lines.length, rules, words };
}

function ResourceCard({ resource }) {
  const { title, kind, date, description, tags = [], content } = resource;
  const { lines, rules, words } = measure(content);
  const clippable = lines > CLIP_AT;

  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const clipped = clippable && !open;

  async function copy() {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  }

  return (
    <article className="entry">
      <div className="entry-rail">
        <p className="entry-spec spec">
          <span className="entry-kind">{kind}</span>
          <time dateTime={date}>{date}</time>
          {rules > 0 && <span>{rules} rules</span>}
          <span>{words} words</span>
        </p>

        {tags.length > 0 && (
          <p className="entry-tags spec">
            {tags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </p>
        )}
      </div>

      <div className="entry-body">
        <div className="entry-head">
          <h2 className="entry-title">{title}</h2>
          <button
            type="button"
            className={`entry-copy spec${copied ? ' is-copied' : ''}`}
            onClick={copy}
          >
            {copied ? 'Copied' : 'Copy'}
          </button>
        </div>

        <p className="entry-note">{description}</p>

        <div className={`entry-artifact${clipped ? ' is-clipped' : ''}`}>
          <pre>{content}</pre>
        </div>

        {clippable && (
          <button
            type="button"
            className="entry-more spec"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
          >
            {open ? 'Collapse' : `Show all ${lines} lines`}
          </button>
        )}
      </div>
    </article>
  );
}

export default ResourceCard;
